import React  from 'react';
import { 
    Section,
    Title,
    TitleSec,
    Name,
    Department,
    SendEmailButton,
    LinkedinButton,
    UserBox,
    UserBoxContainer,
    ImageBox,
    ButtonFlexbox,
    WhiteCircle,
    BoxImage,
    YellowCircle,
    StarImg,
} from './style'
import { Box } from 'reflexbox'
import Profile1 from '../../image/profile1.png'
import Profile2 from '../../image/profile2.png'
import Profile3 from '../../image/profile3.png'
import Email from '../../image/email.png'
import Linkedin from '../../image/linkedin.png'
import Star from '../../image/Star.png'


const data = [
    {
        name: "Agust Syahputra Doloksaribu",
        image: Profile1,
        department: "Managing Partner of Sequoia Advocates"
    },
    {
        name: "Hisar" +
             "\nJohannes",
            image: Profile2,
        department: "Partner of Sequoia Advocates"
    },
    {
        name: "Randolph Yosua Siagian",
        image: Profile3,
        department: "Partner of Sequoia Advocates"
    }
]

export const IntroductingComponents = () => {
    return (
        <Section>
            <Title>
                Introducing Our Legal Experts.{' '}
                <TitleSec>
                    Meet our leading Legal Professionals for Your Legal Needs.
                </TitleSec>
            </Title>
            <UserBoxContainer>
                {data.map((user) => (
                    <UserBox>
                        <BoxImage>
                            <WhiteCircle>
                                <YellowCircle>
                                    <StarImg 
                                        src={Star} 
                                        alt="star" 
                                    />
                                </YellowCircle>
                            </WhiteCircle>
                            <ImageBox 
                                src={user.image} 
                                alt="" 
                            />
                        </BoxImage>
                        <Name>{user.name}</Name>
                        <Department>{user.department}</Department>
                        <ButtonFlexbox>
                            <SendEmailButton>
                                <img 
                                    src={Email} 
                                    alt="" 
                                    width="28px" 
                                    height="auto"
                                />
                                <Box 
                                    marginLeft='16px'
                                    fontFamily='sans-serif'
                                    fontWeight='bold'
                                >
                                    Send email
                                </Box>
                            </SendEmailButton>
                            <LinkedinButton>
                                <div>
                                    <img 
                                        src={Linkedin} 
                                        alt=""
                                        width="26px"
                                        height="26px"
                                    />
                                </div>
                                <Box 
                                    marginLeft='16px'
                                    fontFamily='sans-serif'
                                    fontWeight='bold'
                                >
                                    Let's connect
                                </Box>
                            </LinkedinButton>
                        </ButtonFlexbox>
                    </UserBox>
                ))}
            </UserBoxContainer>
        </Section>
    )
}